import {
    Avatar,
    Box,
    Chip,
    Divider,
    Icon,
    IconButton,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import {
    ForumService,
    IdeaDto,
    IdeaStatus,
    IdeaVisibility,
} from "../../../api/psc";
import {
    ForumProgressList,
    ForumStatusList,
} from "../../../constants/ForumConstants";
import { DialogContext } from "../../../contexts/DialogContext";
import { UserContext } from "../../../contexts/UserContext";
import { toJalaliDate } from "../../../utils/date";
import CreateOrUpdateIdeaDialog from "../Dialogs/CreateOrUpdateIdeaDialog";

export default function IdeaListItem(props: {
    idea: IdeaDto;
    onChange: (idea: IdeaDto) => void;
}) {
    const user = useContext(UserContext);

    const [isLiked, setIsLiked] = useState(props.idea.isLikedByThisUser);
    const [count, setCount] = useState(props.idea.likeCount);

    const { openDialog } = useContext(DialogContext);

    const handleToggleLike = () => {
        ForumService.toggleLike(props.idea.id, "1").then((r) => {
            setIsLiked(!isLiked);
            setCount(r);
        });
    };

    const openIdeaDialog = () => {
        openDialog(
            <CreateOrUpdateIdeaDialog
                onCreateOrUpdate={(result) => {
                    props.onChange(result);
                }}
                idea={props.idea}
            />
        );
    };

    const status = ForumStatusList.find((s) => s.id === props.idea.status);
    const progress = ForumProgressList.find(
        (p) => p.id === props.idea.progress
    );

    return (
        <Paper sx={{ p: 1.5 }}>
            <Stack spacing={1.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar
                        src={props.idea.user.avatarUrl}
                        sx={{ width: 35, height: 35 }}
                    />

                    <Stack spacing={0.5}>
                        <Typography color="primary">
                            {props.idea.user.displayName}
                        </Typography>
                        <Typography color="text.secondary" fontSize="smaller">
                            {toJalaliDate(props.idea.createDate)}
                        </Typography>
                    </Stack>

                    <Box flexGrow={1} />

                    {props.idea.user.id === user.id && (
                        <>
                            <IconButton
                                color="warning"
                                onClick={openIdeaDialog}
                            >
                                <Icon>edit</Icon>
                            </IconButton>
                        </>
                    )}

                    {props.idea.visibility === IdeaVisibility.PUBLIC && (
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.5}
                        >
                            <Typography>{count}</Typography>
                            <IconButton onClick={handleToggleLike} size="small">
                                <Icon
                                    color={isLiked ? "primary" : "disabled"}
                                    fontSize="large"
                                >
                                    {!isLiked ? "star_bordered" : "star"}
                                </Icon>
                            </IconButton>
                        </Stack>
                    )}

                    {props.idea.visibility === IdeaVisibility.PRIVATE && (
                        <Chip
                            size="small"
                            sx={{ color: "white", bgcolor: status.color }}
                            label={status.title}
                        />
                    )}
                </Stack>

                <Divider />

                <Typography color="text.primary">{props.idea.title}</Typography>

                {props.idea.description && (
                    <Typography color="text.secondary">
                        {props.idea.description}
                    </Typography>
                )}

                {props.idea.adminResponse && (
                    <>
                        <Divider />
                        <Typography color="secondary">
                            پاسخ ادمین: {props.idea.adminResponse}
                        </Typography>
                    </>
                )}

                {props.idea.status === IdeaStatus.ACCEPTED && (
                    <>
                        <Divider />
                        <Stack direction="row" alignItems="center">
                            <Typography color="text.secondary">
                                وضعیت پیشرفت
                            </Typography>

                            <Box flexGrow={1} />

                            <Chip
                                size="small"
                                label={progress.title}
                                sx={{ bgcolor: progress.color, color: "white" }}
                            />
                        </Stack>
                    </>
                )}

                {/*{*/}
                {/*    props.idea.visibility === IdeaVisibility.PUBLIC &&*/}
                {/*    <>*/}
                {/*        <Divider/>*/}
                {/*        <Stack direction='row' alignItems='center' spacing={1}>*/}

                {/*            {*/}
                {/*                props.idea.commentCount === 0 &&*/}
                {/*                <Typography color='text.secondary'>نظری ثبت نشده است!</Typography>*/}
                {/*            }*/}

                {/*            {*/}
                {/*                props.idea.commentCount > 0 &&*/}
                {/*                <Typography color='text.secondary'>{props.idea.commentCount} نظر ثبت شده</Typography>*/}
                {/*            }*/}

                {/*            <Box flexGrow={1}/>*/}

                {/*            <Button color='secondary'*/}
                {/*                    startIcon={<Icon color='secondary'>comment</Icon>}*/}
                {/*                    size='small'*/}
                {/*                    variant='outlined'*/}
                {/*                    onClick={openComments}>*/}
                {/*                مشاهده نظرات*/}
                {/*            </Button>*/}
                {/*        </Stack>*/}
                {/*    </>*/}
                {/*}*/}
            </Stack>
        </Paper>
    );
}
